export const labels = {
	startYear: {
		label: "Label.MobileCreator.BottomMenu.Root.Year",
		default: "Year",
	},
	startMonth: {
		label: "Label.MobileCreator.BottomMenu.Root.Month",
		default: "Month",
	},
} as const;
